/**
 * ANS (Apertum Name Service) — same contracts OpenPlaza uses.
 * SportsFuture wallet dropdown shows the primary domain and avatar.
 */

export const ANS_CONFIG = {
  contracts: {
    ansRegistry: '0xEE041dF9A7CF6435c049F80F6D7c052dC4580475',
    publicResolver: '0xd98F3e67960a9671FF69baf265CbCC26c6E88263',
    reverseRegistrar: '0x7b1dB4AAfd7531e267c0f4b68C69c97BF7d1D36f',
    rpcUrl:
      'https://rpc.apertum.io/ext/bc/YDJ1r9RMkewATmA7B35q1bdV18aywzmdiXwd9zGBq3uQjsCnn/rpc',
    chainId: 2786,
    chainName: 'Apertum',
  },
  displayRecords: [] as string[],
  showSections: {
    balance: true,
    domain: true,
    address: true,
    textRecords: false,
    network: true,
  },
};

export type ANSConfig = typeof ANS_CONFIG;
